var React = require('react');

function FaCircleONotch (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M13.75 7q0 1.375-.535 2.625t-1.438 2.152-2.152 1.438T7 13.75t-2.625-.535-2.152-1.438T.785 9.625.25 7q0-1.664.758-3.113T3.078 1.5 6 .32v1.781q-1.727.352-2.863 1.727T2 7q0 1.016.398 1.941t1.066 1.594 1.594 1.066 1.941.398 1.941-.398 1.594-1.066T11.6 8.941 11.998 7q0-1.797-1.137-3.172T7.998 2.101V.32Q9.607.562 10.92 1.5t2.07 2.387T13.748 7z"}));
}

FaCircleONotch.defaultProps = {"width":"14","height":"14"};

module.exports = FaCircleONotch;

FaCircleONotch.default = FaCircleONotch;
